const DASHBOARD_TAB_STORAGE_KEY = 'dxp_dashboard_active_tab'

export const getStoredDashboardActiveTab = (): string | null => {
  if (typeof localStorage === 'undefined') return null

  try {
    return localStorage.getItem(DASHBOARD_TAB_STORAGE_KEY)
  } catch (e) {
    console.error('Failed to load dashboard tab from localStorage:', e)
  }

  return null
}

export const persistDashboardActiveTab = (activeTabTitle: string) => {
  if (typeof localStorage === 'undefined') return

  try {
    localStorage.setItem(DASHBOARD_TAB_STORAGE_KEY, activeTabTitle)
  } catch (e) {
    console.error('Failed to save dashboard tab to localStorage:', e)
  }
}

export const clearDashboardActiveTab = () => {
  if (typeof localStorage === 'undefined') return

  try {
    localStorage.removeItem(DASHBOARD_TAB_STORAGE_KEY)
  } catch (e) {
    console.error('Failed to clear dashboard tab from localStorage:', e)
  }
}
